import { EmptyState, CircleCheckBigIcon } from '@buffer-mono/popcorn'
import * as m from 'motion/react-m'

import { CommentsEngagementPanel } from '../CommentsEngagementPanel'
import type { EmptyStateChannel } from './types'
import { EmptyStateWrapper } from '../../../components/EmptyStates'
import { isGoogleBusinessProfile } from '../../../util/channelHelpers'

import styles from './DefaultEmptyState.module.css'

import type { JSX } from 'react'

const EmptyStateIconMotion = m.create(EmptyState.Icon)

type DefaultEmptyStateProps = {
  justResolvedLastComment?: boolean
  channels?: EmptyStateChannel[]
  postId?: string
}

export const DefaultEmptyState = ({
  justResolvedLastComment,
  channels,
  postId,
}: DefaultEmptyStateProps = {}): JSX.Element => {
  const isGBP = isGoogleBusinessProfile(channels)
  const itemLabel = isGBP ? 'reviews' : 'comments'

  return (
    <EmptyStateWrapper shouldAnimate={justResolvedLastComment}>
      <EmptyState
        size="large"
        variant="success"
        // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- EmptyState is the labelled live status while retaining its Popcorn presentation.
        role="status"
        aria-label={`All ${itemLabel} have been addressed`}
      >
        <div className={styles.animationContainer} aria-hidden="true">
          <EmptyStateIconMotion
            className={styles.emptyStateIcon}
            animate={{
              scale: [1, 1.2, 1],
              transition: {
                duration: 1,
              },
              backgroundColor: [
                'var(--color-bg-success-subtle)',
                'var(--global-color-green-300)',
                'var(--color-bg-success-subtle)',
              ],
            }}
          />
          <CircleCheckBigIcon
            className={styles.checkCircleIcon}
            color="success"
            size="small"
          />
        </div>
        <EmptyState.Heading>
          {justResolvedLastComment
            ? 'Congratulations! This was the last comment 👏'
            : "You're all caught up! 🎉"}
        </EmptyState.Heading>
        <EmptyState.Description>
          We&apos;ll let you know when new {itemLabel} appear.
        </EmptyState.Description>
      </EmptyState>
      {!postId && (
        <CommentsEngagementPanel channels={channels ?? []} postId={postId} />
      )}
    </EmptyStateWrapper>
  )
}
